import { useMemo } from "react";
import styled from "styled-components";
import { Spinner } from "../../components/loaders";
import PortfolioTestResults from "../../features/portfoliotestresults";
import { FilterProvider, PortfolioTestResultDefaultFilters } from "../../hooks/FilterContext";
import { useFetchDefaultServiceLevelAgreementsQuery } from "../../services/clientserviceterms";

const PageSpinner = styled(Spinner)`
    grid-area: main-start;
    justify-self: center;
    align-self: center;
`;

const PortfolioTestResultsPage = () => {
    const { data: slas, isFetching: isFetchingSlas } = useFetchDefaultServiceLevelAgreementsQuery();

    const defaultFilters = useMemo(() => {
        if (isFetchingSlas)
            return null;

        return {
            ...PortfolioTestResultDefaultFilters,
            serviceLevelAgreementIds: slas ? slas.map(x => x.agreementId) : []
        }
    }, [isFetchingSlas, slas]);

    if (isFetchingSlas)
        return <PageSpinner />

    return <FilterProvider defaultFilters={defaultFilters} filterStore={"portfolioTestResults"}>
        <PortfolioTestResults />
    </FilterProvider>
}

export default PortfolioTestResultsPage;